import { Node } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
// import TableCell from '@tiptap/extension-table-cell';
// import TableHeader from '@tiptap/extension-table-header';
import { CustomTableCell, CustomTableHeader } from "./extensions/table_cell_vertical.js";
import CharacterCount from "@tiptap/extension-character-count";
import TextAlign from "@tiptap/extension-text-align";
import TextStyle from "@tiptap/extension-text-style";
import { Color } from "@tiptap/extension-color";
import { Highlight } from "@tiptap/extension-highlight";
import { EditorTheme } from "./theme.js";
import { LineHeightExtension } from "./extensions/line_height.js";
import { ParagraphSpacingExtension } from "./extensions/spacing.js";
import { FontSize } from "./extensions/font_size.js";
import { CustomImage } from "./extensions/image.js";

// Custom ToC Node
const TableOfContentsNode = Node.create({
  name: "tableOfContents",
  group: "block",
  atom: true,
  parseHTML() {
    return [{ tag: 'div[data-type="toc"]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      {
        "data-type": "toc",
        class:
          "toc-placeholder p-4 bg-base-200 border border-base-300 rounded-lg my-4 text-center text-base-content/50 italic text-sm select-none",
      },
      "Table of Contents (PDF Placeholder)",
    ];
  },
});

export const EXTENSIONS = [
  StarterKit.configure({
    heading: { levels: [1, 2, 3] },
  }),
  CustomImage.configure({
    HTMLAttributes: {
      class: EditorTheme.image,
    },
  }),
  Underline,
  Link.configure({
    openOnClick: false,
    HTMLAttributes: {
      class: EditorTheme.link,
    },
  }),
  Table.configure({
    resizable: true,
    HTMLAttributes: {
      class: EditorTheme.table,
    },
  }),
  TableRow,
  CustomTableHeader.configure({
    HTMLAttributes: {
      class: EditorTheme.header,
    },
  }),
  CustomTableCell.configure({
    HTMLAttributes: {
      class: EditorTheme.cell,
    },
  }),
  CharacterCount,
  TextAlign.configure({
    types: ["heading", "paragraph"],
  }),
  TextStyle,
  Color,
  Highlight.configure({
    multicolor: true,
  }),
  LineHeightExtension,
  ParagraphSpacingExtension,
  FontSize,
  TableOfContentsNode,
];

export interface FloatingMenuConfig {
  id: string;
  shouldShow: (props: any) => boolean;
  tippyOptions?: any;
}

export const FLOATING_MENUS: FloatingMenuConfig[] = [
  {
    id: "bubble-menu-table",
    shouldShow: ({ editor }) => editor.isActive("table"),
    tippyOptions: {
      placement: "top",
      maxWidth: "none",
      zIndex: 9999,
    },
  },
  {
    id: "bubble-menu-image",
    shouldShow: ({ editor }) => editor.isActive("image"),
    tippyOptions: {
      placement: "top",
      maxWidth: "none",
      zIndex: 9999,
    },
  },
];

export const EDITOR_PROPS = {
  attributes: {
    class: "focus:outline-none min-h-full document-content tiptap-editor-canvas",
  },
};
